import React from 'react';

const Logo = () => {
  return (
    <p className="title is-spaced">
      <span className="mb-4">
        <span className="has-background-link has-text-white is-size-3 mr-3" style={{ borderRadius: '8px', padding: "4px 9.7px"}}>n</span>
        <span className="my-auto has-text-weight-medium is-size-5">
          nargklab
        </span>
      </span>
    </p>
  );
};

export default Logo;
